// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1OKUa","alert":"SettungsInbox_alert__2Px02"};